export enum videos {
    intro = 'https://lastkings-public.s3.us-east-2.amazonaws.com/Intro.mp4',
}
